export default __webpack_public_path__ + "static/media/IndiaSoft-2018.61ffb4dc.jpg";